import WmsLayer from './WmsLayer';
import { pzgikAttribution } from './attribution';

export default class MpzpLayer extends WmsLayer {
    static ID = 'mpzp';
    static DESCRIPTION = 'Miejscowe plany zagospodarowania przestrzennego';
    static MIN_ZOOM = 16;

    getWmsConfig() {
        return {
            url: 'https://mapy.geoportal.gov.pl/wss/ext/KrajowaIntegracjaMiejscowychPlanowZagospodarowaniaPrzestrzennego',
            params: {
                LAYERS: 'raster',
                FORMAT: 'image/png',
                TRANSPARENT: 'true',
                VERSION: '1.1.1'
            },
            opacity: 1,
            attribution: pzgikAttribution('miejscowe plany zagospodarowania przestrzennego')
        };
    }
}
